import { Component, ProgressBar, _decorator } from 'cc';
import SupportLanguage from '../../../common/scripts/I18n/SupportLanguage';
import LocalizedString, { LocalizedStringLanguage } from '../../../common/scripts/Toolkit/Components/LocalizedComponent/LocalizedString';

const { ccclass, property } = _decorator;

const defaultLoadingMap: LocalizedStringLanguage = {
    [SupportLanguage.ENG]: 'Loading...{0}%',
    [SupportLanguage.SCH]: '加载中...{0}%',
    [SupportLanguage.TCH]: '載入中...{0}%',
    [SupportLanguage.KR]: '로딩 중...{0}%',
    [SupportLanguage.JP]: 'ローディング...{0}%',
    [SupportLanguage.ID]: 'Sedang Memuat...{0}%',
    [SupportLanguage.PT]: 'Carregando...{0}%',
    [SupportLanguage.ES]: 'Cargando...{0}%',
    [SupportLanguage.VI]: 'Đang tải...{0}%',
    [SupportLanguage.TH]: 'กำลังโหลด…{0}%',
    [SupportLanguage.FIL]: 'Nagloload...{0}%',
    [SupportLanguage.MS]: 'Sedang Memuat...{0}%',
    [SupportLanguage.HI]: 'Loading...{0}%',
    [SupportLanguage.TR]: 'Loading...{0}%',
    [SupportLanguage.RU]: 'Loading...{0}%',
    [SupportLanguage.BN]: 'Loading...{0}%',
    [SupportLanguage.MY]: 'Loading...{0}%',
    [SupportLanguage.DE]: 'Loading...{0}%',
    [SupportLanguage.HKT]: 'Loading...{0}%',
};
@ccclass('PreloadView')
export default class PreloadView extends Component {
    @property(ProgressBar)
    protected readonly progressBar: ProgressBar = null;

    @property(LocalizedString)
    protected readonly progressMessage: LocalizedString = null;

    public onLoad() {
        this.progressMessage.loadConfig(defaultLoadingMap);
    }

    public updateProgress(value: number): void {
        if (this.progressBar.progress >= value) {
            return;
        }
        this.progressBar.progress = value;
        this.progressMessage.string = Math.floor(value * 100).toString();
    }

    public resetProgress(): void {
        this.progressBar.progress = 0;
        this.progressMessage.string = '0';
    }
}
